import { DateTime } from 'luxon'

export default class ValidationService {
  constructor(form) {
    this.form = form
  }

  checkFieldsExistence(requiredFields) {
    this.badFields = []
    requiredFields.forEach((field) => {
      if (this.form[field] == '') this.badFields.push(field)
    })

    return { valid: this.badFields.length == 0, badFields: this.badFields }
  }

  isEndReportLaterThanStart() {
    const startReport = DateTime.fromFormat(
      this.form.reportTime,
      'yyyy-MM-dd HH:mm'
    )
    const endReport = DateTime.fromFormat(
      this.form.endReportTime,
      'yyyy-MM-dd HH:mm'
    )
    return startReport.toMillis() + 60001 < endReport.toMillis()
  }

  isDateInTheFuture(property) {
    const date = DateTime.fromFormat(this.form[property], 'yyyy-MM-dd HH:mm')
    return date.toMillis() > DateTime.local().toMillis()
  }

  reportTimesInFuture() {
    return (
      this.isDateInTheFuture('reportTime') ||
      this.isDateInTheFuture('endReportTime')
    )
  }
}
